import styled, { keyframes } from 'styled-components/macro'
import { ProgressBar } from 'react-bootstrap'
import palette from 'src/designSystem/variables/palette'

const shimmerAnimation = keyframes`  
  0% {
    background-position: -400px 0;
  }
  
  100% {
    background-position: 400px 0; 
  }
`

export const StyledProgressBar = styled(ProgressBar)`
  &.progress {
    position: relative;
    height: 1em;
    max-width: 365px;
    border-radius: 10px;
    background: linear-gradient(
      90deg,
      ${palette.neutral[50]} 0%,
      ${palette.neutral[200]} 15%,
      ${palette.neutral[50]} 30%,
      ${palette.neutral[50]} 100%
    );
    background-repeat: no-repeat;
    animation: ${shimmerAnimation} 2s ease-out infinite;
    // Ensure that this is last to get background effect
    background-color: ${palette.neutral[50]};
  }

  &.progress::after {
    content: '';
    position: absolute;
    height: 100%;
    background-color: ${palette.neutral[50]};
    box-sizing: border-box;
  }

  .progress-bar {
    background-color: ${palette.green[300]};
  }
`

export const ProgressMeterContainer = styled.div`
  margin: 0.5em 0 1em 0;

  p {
    font-size: 14px;
    font-weight: 400;
    color: ${palette.neutral[600]};
  }
`

export const ProgressMeterTitle = styled.h3<{
  $fontSize?: number
  $fontWeight?: number
  $isDim?: boolean
}>`
  ${({ $fontSize }) => `font-size: ${$fontSize ? $fontSize : 18}px`};
  ${({ $fontWeight }) => `font-weight: ${$fontWeight ? $fontWeight : 500}`};
  ${({ $isDim }) => `${$isDim && `color: ${palette.neutral['500']}`}`};
`
